var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGcpinline = function SvgGcpinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.964 21.575h1.806l5.145-5.01.252-2.128c-9.576-8.232-24.192-7.343-32.646 1.982a22.339 22.339 0 0 0-4.982 9.008 2.855 2.855 0 0 1 1.805-.104l10.291-1.654s.523-.845.796-.793c4.577-4.896 12.281-5.467 17.569-1.3h-.036Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.248 25.427a22.476 22.476 0 0 0-6.986-10.97L40.04 21.49c3.049 2.426 4.786 6.083 4.712 9.917v1.25c3.55 0 6.428 2.802 6.428 6.26 0 3.456-2.878 6.259-6.428 6.259H31.896l-1.283 1.266v7.51l1.283 1.248h12.857c9.232.07 16.776-7.162 16.847-16.152.043-5.46-2.718-10.568-7.352-13.62Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.022 55.119h12.856V45.098H19.022c-.917 0-1.82-.194-2.655-.564l-1.805.546-5.181 5.01-.451 1.759a16.89 16.89 0 0 0 10.092 3.27Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.019 22.613c-9.236.052-16.674 7.384-16.62 16.377.032 5.021 2.437 9.748 6.528 12.807l7.455-7.26c-3.234-1.422-4.673-5.132-3.213-8.28 1.461-3.15 5.27-4.55 8.504-3.129a6.361 6.361 0 0 1 3.212 3.129l7.456-7.26c-3.17-4.042-8.102-6.405-13.322-6.384Z",
    fill: "currentColor"
  })));
};

export default SvgGcpinline;